import { customerApi } from "../../utils/apiConfig";
export const uploadIadeRapor = ({
  file,
  startDate,
  endDate,
  cari,
  kullaniciToplamTonaj,
  totalYearsTips,
  recordsTopN,
  recordTip,
}) => {
  const formData = new FormData();

  if (file) formData.append("excel", file);
  if (startDate) formData.append("startDate", startDate);
  if (endDate) formData.append("endDate", endDate);
  if (cari) formData.append("cari", cari);
  if (kullaniciToplamTonaj)
    formData.append("kullaniciToplamTonaj", String(kullaniciToplamTonaj));
  if (totalYearsTips) formData.append("totalYearsTips", String(totalYearsTips));
  if (recordsTopN) formData.append("recordsTopN", String(recordsTopN));
  if (recordTip) formData.append("recordTip", String(recordTip));

  return customerApi.post("/IadeAnalizFormat", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const uploadSevkRapor = ({ file }) => {
  const formData = new FormData();

  if (file) formData.append("excel", file);

  return customerApi.post("/sevkForIade", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
